<template>
  <div id="Portrait">
    <section class="pic-loop-wrapper pos-c">
      <LoopPic :pic-arr="picArr"/>
    </section>
    <guide-button class="btn-lt" @click="$router.push('/Part04/Representative')">返回</guide-button>
    <guide-button class="btn-rt" @click="$router.push('/Part04/Institution')">继续</guide-button>
  </div>
</template>

<script>
export default {
  name: 'Portrait',
  data () {
    return {
      picArr: [],
    }
  },
  mounted () {
    this.initStart()
  },
  methods: {
    initStart () {
      for (let i = 1; i < 10; i++) {
        this.picArr.push({
          img: `/img/Portrait/${i}.png`,
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#Portrait {
  height: 100%;
}
.pic-loop-wrapper  {
  width: 13rem;
  height: 7rem;
}
</style>
